import * as Sentry from '@sentry/react';

import {
    createUserAuthentication,
    UserAuthenticationConfig,
} from '@barboxx/react-utils';

import {
    clearStoredValues,
    getStoredValues,
    setStoredValues,
} from '../helpers/localStorage';

const config: UserAuthenticationConfig = {
    // allowedUserTypes: ['Business'],
    persistOptions: {
        get: getStoredValues as any,
        set: setStoredValues,
        clear: clearStoredValues,
        storeRefreshToken: false,
    },
    hasRefreshToken: async () => {
        return true;
    },
    onSetUser(user) {
        Sentry.setUser({
            id: user.id,
            email: user.email,
        });
        Sentry.setTag('userType', user.userType);
        Sentry.setTag('userRoles', user.roles.join(','));
    },
};

const { AuthProvider, useAuth } = createUserAuthentication(config);

export { AuthProvider, useAuth };
